import { apiServiceBranches } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'service-branches';

const config = [{ actionType: 'getAll', apiPath: apiServiceBranches, method: get, actionParams: { limit: 0 } }];

export const { getAll } = createThunks(typePrefix, config);
